import { render, staticRenderFns } from "./EmtaRegistrationModal.vue?vue&type=template&id=2e5732d5"
import script from "./EmtaRegistrationModal.vue?vue&type=script&lang=js"
export * from "./EmtaRegistrationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e5732d5')) {
      api.createRecord('2e5732d5', component.options)
    } else {
      api.reload('2e5732d5', component.options)
    }
    module.hot.accept("./EmtaRegistrationModal.vue?vue&type=template&id=2e5732d5", function () {
      api.rerender('2e5732d5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/emta/EmtaRegistrationModal.vue"
export default component.exports